<template>
<div class="team-case">
  <div class="team-case__title">{{$t('pageHome.case.team')}}</div>
  <div
    class="team-case__content"
    ref="contentRef"
    @mouseenter="pause"
    @mouseleave="resume"
  >
    <ul class="list" ref="listRef">
      <li v-for="(item,index) in list" :key="index">
        <div class="item">
          <div class="logo-img">
            <img :src="require(`./images/${item.logo}.png`)" alt="">
          </div>
          <div class="title">{{item.title}}</div>
        </div>
      </li>
    </ul>
<!--    <div class="scroll-bar">-->
<!--      <div class="bar-progress" ref="barRef"></div>-->
<!--    </div>-->
  </div>
</div>
</template>

<script>
export default {
  name: "TeamCase",
  data(){
    return {
      // 0~1 的滚动进度，用于驱动进度条
      progress: 0,
      // 最大可滚动距离（px），由 list 宽度 - 容器宽度计算得到
      maxDistance: 0,
      // 动画开始时间戳（ms）
      startedAt: 0,
      // requestAnimationFrame id
      rafId: 0,
      // 水平滚动速度：px/秒（用于让速度保持相对恒定）
      speed: 40,
      // 进度条滑块最大可移动距离（px），由条容器宽度 - 滑块宽度计算得到
      barMaxLeft: 0,
      // 是否处于暂停状态（鼠标悬停时暂停）
      paused: false,
      // 暂停时已消耗的耗时（ms），用于恢复时无跳变
      pauseElapsed: 0,
      list: [
        {
          title:"喔趣科技",
          logo:"pic-logo-wq",
        },
        {
          title:"蓝箭航天",
          logo:"pic-logo-lj",
        },
        {
          title:"云生集团",
          logo:"pic-logo-ys",
        },
        // {
        //   title:"XTIA",
        //   logo:"pic-logo-xtia",
        // },
        {
          title:"欧莱新材",
          logo:"pic-logo-ol",
        },
        {
          title:"极豆",
          logo:"pic-logo-jd",
        },
        // {
        //   title:"POLYVOLY 保利沃利",
        //   logo:"pic-logo-bl",
        // },
        // {
        //   title:"IPSTAR",
        //   logo:"pic-logo-ipstar",
        // },
        // {
        //   title:"SELZ",
        //   logo:"pic-logo-selz",
        // },
        // {
        //   title:"时光迹",
        //   logo:"pic-logo-sgj",
        // },
        // {
        //   title:"Course Centre",
        //   logo:"pic-logo-CourseCentre",
        // }
      ]
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.measure();
    //   this.measureBar();
    //   // 从右往左：内容向左滑动，进度为 0 时展示左侧
    //   this.applyByProgress(0);
    //   this.startedAt = performance.now();
    //   this.tick();
    // });
    // window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy() {
    // if (this.rafId) cancelAnimationFrame(this.rafId);
    // window.removeEventListener('resize', this.onResize);
  },
  methods: {
    measure() {
      const contentEl = this.$refs.contentRef;
      const listEl = this.$refs.listRef;
      if (!contentEl || !listEl) return;

      const contentWidth = contentEl.clientWidth;
      // scrollWidth 能拿到因为 white-space: nowrap 导致的总宽度
      const listWidth = listEl.scrollWidth;
      this.maxDistance = Math.max(0, listWidth - contentWidth);
    },
    measureBar() {
      const scrollBarEl = this.$el.querySelector('.scroll-bar');
      const barEl = this.$refs.barRef;
      if (!scrollBarEl || !barEl) return;

      const trackWidth = scrollBarEl.clientWidth;
      const barWidth = barEl.offsetWidth;
      this.barMaxLeft = Math.max(0, trackWidth - barWidth);
    },
    // 根据进度 0~1 设置 translateX：内容向左滑动（translateX 递减）
    applyByProgress(p) {
      const listEl = this.$refs.listRef;
      const barEl = this.$refs.barRef;
      if (!listEl || !barEl) return;

      const safeP = Math.min(1, Math.max(0, p));
      this.progress = safeP;

      // maxDistance=0 时不需要移动
      const x = this.maxDistance <= 0 ? 0 : -this.maxDistance * safeP;
      listEl.style.transform = `translate3d(${x}px, 0, 0)`;

      // 固定宽度滑块：根据滚动距离百分比计算 left
      const left = this.barMaxLeft <= 0 ? 0 : this.barMaxLeft * safeP;
      barEl.style.left = `${left}px`;
    },
    getDurationMs() {
      if (this.maxDistance <= 0) return 0;
      return (this.maxDistance / this.speed) * 1000;
    },
    tick() {
      // 暂停时冻结进度：不更新位移/进度条，也不继续调度下一帧
      if (this.paused) return;

      // 如果无需滚动，则保持展示，并将进度条置满
      const durationMs = this.getDurationMs();
      if (durationMs <= 0) {
        this.applyByProgress(1);
        this.rafId = 0;
        return;
      }

      const now = performance.now();
      const elapsed = now - this.startedAt;
      let p = elapsed / durationMs;

      // 循环滚动：到头后从右侧重新开始
      if (p >= 1) {
        this.applyByProgress(0);
        this.startedAt = performance.now();
        if (!this.paused) this.rafId = requestAnimationFrame(this.tick);
        return;
      }

      this.applyByProgress(p);
      if (!this.paused) this.rafId = requestAnimationFrame(this.tick);
    },
    pause() {
      if (this.paused) return;
      this.paused = true;

      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = 0;

      const durationMs = this.getDurationMs();
      // 用 startedAt 计算当前走过的耗时，恢复时继续从这里开始
      this.pauseElapsed = durationMs <= 0 ? 0 : (performance.now() - this.startedAt);
    },
    resume() {
      if (!this.paused) return;
      this.paused = false;

      // 从暂停点继续：startedAt = 当前时间 - 暂停时已消耗耗时
      this.startedAt = performance.now() - this.pauseElapsed;
      this.tick();
    },
    onResize() {
      // resize 时：重新测量 maxDistance，同时根据当前进度修正动画计时，
      // 保证视觉不会突然跳变，且“滚动距离”按新尺寸变化。
      this.measure();
      this.measureBar();
      const newDuration = this.getDurationMs();

      if (newDuration <= 0) {
        this.applyByProgress(1);
        this.pauseElapsed = 0;
        return;
      }

      this.applyByProgress(this.progress);

      // 暂停时：不动 startedAt，只更新 pauseElapsed，让恢复后进度不跳变
      if (this.paused) {
        this.pauseElapsed = this.progress * newDuration;
        return;
      }

      // 非暂停：继续保持当前进度比值（translateX 和进度条不跳变）
      this.startedAt = performance.now() - this.progress * newDuration;

      // 如果此前因为 maxDistance=0 已经停止动画，则在 resize 后重新启动
      if (!this.rafId) this.rafId = requestAnimationFrame(this.tick);
    }
  }
}
</script>

<style scoped lang="scss">
.team-case{
  height: 401px;
  background: #EFEFEF;
  .team-case__title{
    padding-top: 61px;
    padding-bottom: 39px;
    color: rgba(35, 25, 22, 1);
    font-size: 32px;
    line-height: 32px;
    text-align: center;
    font-weight: 600;
  }
  .team-case__content{
    overflow: hidden;
    width: 1400px;
    margin-left: auto;
    margin-right: auto;
  }
  .list{
    white-space: nowrap;
    margin-bottom: 40px;
    // 提高 transform 性能
    will-change: transform;
    >li{
      display: inline-block;
      margin-right: 40px;
      &:last-child{
        margin-right: 0px;
      }
      .item{
        .logo-img{
          width: 246px;
          height: 140px;
          margin-bottom: 8px;
          background: #fff;
          >img{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .title{
          color:rgba(35, 25, 22, 1);
          line-height: 32px;
          text-align: center;
        }
      }
    }
  }
  .scroll-bar{
    width: 320px;
    height: 10px;
    background: rgba(35, 25, 22, 0.1);
    border-radius: 5px;
    position: relative;
    box-sizing: border-box;
    padding: 0;
    margin: 0 auto;
    .bar-progress {
      width: 60px;
      height: 6px;
      background: #231916;
      border-radius: 5px;
      position: absolute;
      left: 0;
      top: 2px;
    }
  }
}
</style>
